document.addEventListener('DOMContentLoaded', function() {

  // ============================================
  // Hero Slider
  // ============================================
  if (typeof Swiper !== 'undefined' && document.querySelector('.vp-slider')) {
    new Swiper(".vp-slider", {
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }

  // ============================================
  // Size Guide Popup
  // ============================================
  const sizeGuideTrigger = document.querySelector(".vp-size-guide-trigger");
  const sizeGuidePopup = document.getElementById("sizeGuidePopup");
  const popupClose = document.querySelector(".vp-popup-close");

  if (sizeGuideTrigger && sizeGuidePopup) {
    sizeGuideTrigger.addEventListener("click", function() {
      sizeGuidePopup.style.display = "flex";
    });

    if (popupClose) {
      popupClose.addEventListener("click", function() {
        sizeGuidePopup.style.display = "none";
      });
    }

    window.addEventListener("click", function(e) {
      if (e.target.id === "sizeGuidePopup") {
        sizeGuidePopup.style.display = "none";
      }
    });
  }

  // ============================================
  // Gallery Tabs
  // ============================================
  const tabs = document.querySelectorAll(".vp-tab-btn-gallery");
  const cards = document.querySelectorAll(".vp-gallery-card");

  if (tabs.length && cards.length) {
    tabs.forEach(function(tab) {
      tab.addEventListener("click", function() {
        tabs.forEach(function(t) {
          t.classList.remove("vp-tabs-active");
        });
        tab.classList.add("vp-tabs-active");

        const category = tab.dataset.category;
        cards.forEach(function(card) {
          card.classList.toggle("hidden", card.dataset.category !== category);
        });
      });
    });

    // Initialize with first tab
    tabs[0].click();
  }

  // ============================================
  // Gallery Swipers
  // ============================================
  if (typeof Swiper !== 'undefined') {
    
    if (document.querySelector('.mySwiper-bedroom')) {
      new Swiper(".mySwiper-bedroom", {
        slidesPerView: 1.5,
        spaceBetween: 0,
        breakpoints: {
          768: { slidesPerView: 3.5 },
          1280: { slidesPerView: 4.5 }
        }
      });
    }

    if (document.querySelector('.mySwiper-livingroom')) {
      new Swiper(".mySwiper-livingroom", {
        slidesPerView: 1.5,
        spaceBetween: 0,
        breakpoints: {
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
          1280: { slidesPerView: 4.5 }
        }
      });
    }

    if (document.querySelector('.mySwiper-bedding')) {
      new Swiper(".mySwiper-bedding", {
        slidesPerView: 1.5,
        spaceBetween: 0,
        breakpoints: {
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
          1280: { slidesPerView: 4.5 }
        }
      });
    }
  }

}); // End DOMContentLoaded